import { useState } from "react";
import { imageSource } from "@/lib/media";

export default function MediaImage({ src, alt = "", name = "", kind = "thumbnail", demo = false, showLabel = true, className = "", ...props }) {
  const [failedSource, setFailedSource] = useState(null);
  const source = demo ? null : imageSource(src);
  if (source && source !== failedSource) {
    return <img {...props} src={source} alt={alt} loading="lazy" referrerPolicy="no-referrer" onError={() => setFailedSource(source)} className={`shrink-0 ${className}`} />;
  }
  const initials = typeof name === "string" ? name.trim().replace(/^@/, "").split(/[\s._-]+/).filter(Boolean).slice(0, 2).map((word) => Array.from(word)[0]).join("").toLocaleUpperCase("fr") : "";
  return (
    <div {...props} role={alt ? "img" : undefined} aria-label={alt || undefined} aria-hidden={alt ? undefined : true} data-media-state={demo ? "demo" : "unavailable"} className={`shrink-0 flex flex-col items-center justify-center bg-muted text-muted-foreground ${className}`}>
      {kind === "avatar" ? <span className="text-xs font-semibold">{initials || "?"}</span> : <>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="h-6 w-6 shrink-0" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="8" cy="8" r="1.5" /><path d="m3 17 5-5 4 4 4-6 5 7" /></svg>
        {showLabel && <span className="mt-2 max-w-full px-3 text-center text-xs leading-snug">{demo ? "Données de démonstration" : "Aperçu indisponible"}</span>}
      </>}
    </div>
  );
}
